var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"item-stars"},on:{"mouseleave":_vm.turnAllStarsOff}},_vm._l((_vm.stars),function(star){return _c('i',{key:star.id,staticClass:"icon-cr",class:{
            'icon-star-yellow': star.isHovered || star.isSelected,
            'icon-star': !star.isHovered,
        },style:({ cursor: 'pointer' }),attrs:{"id":star.id},on:{"mouseenter":function($event){return _vm.triggerStar(star)},"click":function($event){return _vm.selectStar(star)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }